import React, { useCallback, useEffect, useState } from "react";
import styles from './index.module.css';
import TableSkeleton from "../../Skeleton";
import NoResultsFound from "../../NoResultsFound";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getAllActiveWinners } from "../../../redux/features/winner/winnerServices";

const LatestWinners = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { isWinnersLoading, winners } = useSelector((state) => state.winner.allActiveWinners);

  const fetchWinners = useCallback(
    (filters = {}) => {
      const params = {
        skip: 1,
        limit: 10,
        ...filters,
      };
      dispatch(getAllActiveWinners(params));
    },
    [dispatch]
  );

  useEffect(() => {
    fetchWinners();
  }, [fetchWinners]);

  if (isWinnersLoading || (winners && winners.length > 0)) {
    return (
      <div className={styles.resultsContainer}>
        <div className={`main-container`}>
          <div className={`container-content`}>
            <div className={styles.homeHeader}>
              <h1 className={styles.listingTitle}>{t(`Latest Winners`)}</h1>
            </div>
            <div className={styles.resultsCardSection}>
              {isWinnersLoading ? (
                <TableSkeleton
                  columns={[t(`Username`), t(`Lottery Name`), t(`Date`), t(`Draw`),  `${t('Winning Price')} (${t('Rs')})`]}
                  rowCount={10}
                  height={15}
                />
              ) : (
                winners?.length > 0 && (
                  <div className={`table-container`}>
                    <table className={`table ${styles.winnersTable}`}>
                      <thead className={`thead ${styles.winnersTableHeader}`}>
                        <tr>
                          <th className={`theadColumnOne ${styles.colOne}`}>{t(`Username`)}</th>
                          <th>{t(`Lottery Name`)}</th>
                          <th>{t(`Date`)}</th>
                          <th>{t(`Draw`)}</th>
                          <th>{t(`Winning Price`)} ({t(`Rs`)})</th>
                        </tr>
                      </thead>
                      <tbody className={`tbody ${styles.winnersTbBody}`}>
                        {winners.map((ticket) => (
                          <tr key={ticket.id}>
                            <td className={`tdataColumnOne`}>
                              {ticket.user.username}
                            </td>
                            <td>{ticket.lottery.lottery_brand_day.lottery_brand.name}</td>
                            <td>{ticket.lottery.draw_date}</td>
                            <td>{ticket.lottery.draw_no}</td>
                            <td>{ticket.winning_price.toFixed(2)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    );
  } 
};

export default LatestWinners;
